//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 400
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: ''
    },
    si_text: {
      type: String,
      default: 'Si'
    },
    no_text: {
      type: String,
      default: 'No'
    },
    disableSiButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  methods: {
    onClose: function onClose() {
      this.isOpen = false;
    },
    onOpen: function onOpen() {
      this.isOpen = true;
    },
    onConfirm: function onConfirm(ope) {
      this.$emit('onConfirm', ope);
    }
  }
};